<template>
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size.sync="perPage"
        layout="prev, pager, next, jumper,total"
        :total.sync="total"
        class='diy-page'
        >
    </el-pagination>
</template>
<script>
export default {
    props:["page", "perPage", "total", "totalPage"],
    data(){
      return {
        currentPage: 1,
      }
    },
    methods:{
         //页码
     handleCurrentChange(val) {
       this.$emit('changePage',val);
      }
    }
}
</script>
<style lang="less">
   .el-pager li.active{
       color: #FF3A3A;
   }
   .el-pagination__total{
       margin-left: 21px;
   }
</style>



// WEBPACK FOOTER //
// src/components/layout/pagination.vue